import classNames from 'classnames';
import { FC, HTMLAttributes } from 'react';

import { Icon, Typography } from '@/shared/ui';

import './StatusStep.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  step: number;
  maxSteps: number;
}

export const StatusStep: FC<Props> = ({ className, step, maxSteps, ...restProps }) => {
  const isLastStep = step === maxSteps;
  return (
    <div
      {...restProps}
      className={classNames('custom-status-step', className, {
        'custom-status-step--is-last': isLastStep,
      })}
    >
      <Icon name={isLastStep ? 'check_circle' : 'draft_process'} className="custom-status-step__icon" />
      <Typography color={isLastStep ? 'white' : 'black'} className="custom-status-step__text" variant="TEXT14">
        Заповнено кроків: {step} з {maxSteps}
      </Typography>
    </div>
  );
};
